module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.61571e87.svg";